// @ts-nocheck
import Button from 'antd/lib/button';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { Selects } from '../../../../components';
import { RangePicker } from '../../../../components/ant/DatePicker';
import Field from '../../../../components/card/Field';
import { Filter } from '../../../../components/hoc';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import OrgUnitSelect from '../../../../components/OrgUnitSelect';
import Spoiler from '../../../../components/ui/Spoiler';
import { formatDateTimeToISOString } from '../../../../lib/helpers';
const {
  VehicleSelect,
  DriverSelect
} = Selects;
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-qkmmew-0"
})(["padding:16px;"]);
const Footer = styled(GridItem).withConfig({
  displayName: "Filter__Footer",
  componentId: "sc-qkmmew-1"
})(["& > *{margin-right:16px;&:last-child{margin-right:0;}}"]);
const ReportDriverFilter = ({
  filter,
  applyFilter,
  cleanFilter,
  employeeBranchOrgUnitId
}) => <Spoiler defaultExpanded label="Параметры">
    <SpoilerContent>
      <Grid gutter="16px" media={[{
      size: 'lg',
      cols: 3
    }]}>
        <Filter initialValues={filter} applyFilter={applyFilter} cleanFilter={cleanFilter}>
          {({
          values,
          changeValue,
          applyFilter,
          cleanFilter
        }) => <>
              <GridItem>
                <Field label="Подразделение">
                  <OrgUnitSelect allowClear value={values.orgUnitId} onChange={id => changeValue('orgUnitId', id)} />
                </Field>
              </GridItem>
              <GridItem>
                <Field label="Государственный регистрационный знак ТС">
                  <VehicleSelect allowClear value={values.vehicleId} mode="multiple" optionTitle={vehicle => vehicle.licensePlate} onChange={values => changeValue('vehicleId', values)} />
                </Field>
              </GridItem>
              <GridItem>
                <Field label="Водитель">
                  <DriverSelect allowClear value={values.driverId} mode="multiple" onChange={values => changeValue('driverId', values)} filter={{
                'employee.nodeId': employeeBranchOrgUnitId,
                nodeFilterType: 'branchAndChildren'
              }} />
                </Field>
              </GridItem>
              <GridItem>
                <Field label="Отчетный период">
                  <RangePicker format="DD.MM.YYYY HH:mm" showTime={{
                format: 'HH:mm',
                defaultValue: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')]
              }} placeholder={['Начало', 'Конец']} value={[values.startDate ? moment.utc(values.startDate) : null, values.endDate ? moment.utc(values.endDate) : null]} onChange={(value, dateString) => {
                const [startDate, endDate] = value;
                const [startDateString, endDateString] = dateString;
                changeValue('startDate', formatDateTimeToISOString(startDate, startDateString));
                changeValue('endDate', formatDateTimeToISOString(endDate, endDateString));
              }} />
                </Field>
              </GridItem>
              <Footer fullWidth>
                <Button type="primary" onClick={applyFilter}>
                  Применить
                </Button>
                <Button type="secondary" onClick={cleanFilter}>
                  Очистить
                </Button>
              </Footer>
            </>}
        </Filter>
      </Grid>
    </SpoilerContent>
  </Spoiler>;
export default ReportDriverFilter;
